import Header from '../modules/Header';
import Split from '../modules/Split';
import Hero from '../modules/Hero';
import Carousel from '../modules/Carousel';
import Accordion from '../modules/Accordion';
import InteractiveMap from '../modules/InteractiveMap';
import Registration from '../modules/Registration';
import Dropdown from '../modules/Dropdown';
import Video from '../modules/Video';
import LenisScroll from '../modules/LenisScroll';

export default class ModuleFactory {
    constructor(app) {
        this.app = app; // Keep reference to main App
        this.modules = {
            Header,
            Split,
            Hero,
            Carousel,
            Accordion,
            InteractiveMap,
            Registration,
            Dropdown,
            Video,
            LenisScroll,
        };
        this.instances = [];
    }

    init() {
        const elements = document.querySelectorAll('[data-module]');
        elements.forEach((el) => {
            const name = el.dataset.module;

            if (this.modules[name]) {
                if (el.dataset.initialized === 'true') return;

                const instance = new this.modules[name](el, this.app);
                this.instances.push(instance);

                el.module = instance;

                el.dataset.initialized = 'true';
            }
        });
    }
}
